export const FACTORY_ADDRESSES = [
  { name: "ViperSwap", address: "0x7D02c116b98d0965ba7B642ace0183ad8b8D2196" },
  { name: "SushiSwap", address: "0xc35DADB65012eC5796536bD9864eD8773aBc74C4" },
  { name: "DFK", address: "0x9014B937069918bd319f80e8B3BB4A2cf6FAA5F7" },
  { name: "Defira", address: "0xF166939E9130b03f721B0aE5352CCCa690a7726a" },
  { name: "SonicSwap", address: "0x653FB617210ca72DC938f8f4C75738F2B4b88d7B" },
];
